const escapeRegExp = (str: string) => {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

export const replaceAll = (str: string, find: any, replace: string) => {
  return str.replace(new RegExp(escapeRegExp(find), 'g'), replace)
}
